import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import AttendeeLoginForm from './attendee-login-form';
import { EventIdVerification} from '../../../services/event/eventid-verification'; 
import Loader from '../../../utils/loader/loader';
import { toast } from 'react-toastify';

const AttendeeLoginView = () => {
  const { eventId } = useParams();
  const [responseStatus, setResponseStatus] = useState<number | null>(null); 
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [eventData, setEventData] = useState();
  const navigate = useNavigate()

  useEffect(() => {
    const verifyEventId = async () => {
      try {
        const response = await EventIdVerification(eventId || '');
        if (response.status === 200) {
          setResponseStatus(response.status);
          setEventData(response.data.data); 
        } else {
          setErrorMessage('Invalid Event ID');
        }
      } catch (error) {
        console.error('Error verifying event ID:', error);
        setErrorMessage('Error verifying event ID');
        navigate(`/404}`)
      } finally {
        setIsLoading(false);
      }
    };
    verifyEventId();
  }, [eventId]); 

  return (
    <div>
      {isLoading ? (
        <Loader />
      ) : (
        responseStatus === 200 ? (
          <AttendeeLoginForm eventData={eventData}/>
        ) : (
          <div>{errorMessage}</div>
        )
      )}
    </div>
  );
};

export default AttendeeLoginView;
